import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { NodeStatus } from './ClusterNodeStates';
import { ClusterNodeStatus } from './ClusterNodeStatus';

export type ClusterNodePresenceIconProps = Readonly<{
  status: ClusterNodeStatus;
  clusterNodeStatus: { readonly [s in ClusterNodeStatus]: NodeStatus };
}>;

export function ClusterNodePresenceIcon(props: ClusterNodePresenceIconProps) {
  const { status: state, clusterNodeStatus } = props;
  return <img
      className={statusIconClass}
      title={clusterNodeStatus[state] === undefined ? clusterNodeStatus.Available.stateText :clusterNodeStatus[state].stateText}
      src={imgPath(clusterNodeStatus[state] === undefined ? clusterNodeStatus.Available.stateImage : clusterNodeStatus[state].stateImage)}
      alt={''}
    />;
}

export const statusIconClass = style({
  verticalAlign: 'text-bottom',
  marginRight: TabStyles.Spacing.DefaultSpace
});
